import { streamLainAnimationController } from '@blocksuite/affine/shared/utils';
import { useLayoutEffect, useRef } from 'react';

/** The persistent document stage slides independently of navigation chrome. */
export function useDocumentNavigationMotion(
  documentStage: HTMLDivElement | null,
  documentId: string | undefined,
  pathname: string
) {
  const documentMotion = useRef<ReturnType<
    typeof streamLainAnimationController.play
  > | null>(null);
  const previousRoute = useRef({ pathname, documentId });
  useLayoutEffect(() => {
    const before = previousRoute.current;
    previousRoute.current = { pathname, documentId };
    if (before.pathname !== pathname) {
      documentMotion.current?.cancel();
      documentMotion.current = null;
    }
    if (!documentStage || !documentId || before.documentId === documentId)
      return;
    if (before.pathname !== '/all') return;
    // Slide the document and its already warm load mask together. The sidebar
    // lives beside this stage in the persistent navigation host and stays put.
    const motion = streamLainAnimationController.play(
      documentStage,
      [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
      'page'
    );
    documentMotion.current = motion;
  }, [documentId, documentStage, pathname]);
  useLayoutEffect(
    () => () => {
      documentMotion.current?.cancel();
      documentMotion.current = null;
    },
    [documentStage]
  );
}
